module.exports = __webpack_public_path__ + "static/media/HAUX_NUTRICAO_3.69473688.pdf";